import { OfflineStorage } from "./estrylib";

export const RequestStatusWaitingForApproval = "WaitingForApproval";
export const RequestStatusWaitingForEditing = "WaitingForEditing";
export const RequestStatusWaitingForCancellation = "WaitingForCancellation";
export const RequestStatusModificationApproved = "ModificationApproved";
export const RequestStatusModificationDeclined = "ModificationDeclined";
export const RequestStatusCancellationApproved = "CancellationApproved";
export const RequestStatusCancellationDeclined = "CancellationDeclined";
export const RequestStatusApproved = "Approved";
export const RequestStatusDeclined = "Declined";
export const RequestStatusCancelled = "Cancelled";
export const RequestStatusProcessing = "Processing";
export const RequestStatusWaitingForPrice = "WaitingForPrice";
export const RequestStatusPriceSet = "PriceSet";
export const RequestStatusPriceApproved = "PriceApproved";
export const RequestStatusPriceDeclined = "PriceDeclined";
export const RequestStatusCancellation = "Cancellation";
export const RequestStatusHasNoPolicyNo = "HasNoPolicyNo";
export const RequestStatusRefund = "Refund";
